/** PURE_IMPORTS_START _reduce PURE_IMPORTS_END */
import { reduce } from './reduce';
export function max(comparer) {
    var max = (typeof comparer === 'function')
        ? function (x, y) { return comparer(x, y) > 0 ? x : y; }
        : function (x, y) { return x > y ? x : y; };
    return reduce(max);
}
//# sourceMappingURL=max.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/operators/max.js
// module id = 1992
// module chunks = 0